@if (!((store.value$ | async)?.error)) {
  <div class="rate-card-details-page container-fluid" [formGroup]="formGroup">

    <div class="page-header">
      <button class="arrow-left" (click)="onClickBack()" aria-label="Back">
        <span class="mdi mdi-arrow-left"></span>
      </button>
      <div class="mat-h3 page-title">{{ ratecards ? 'Edit rate card' : 'New rate card' }}</div>
    </div>

    <mat-card appearance="outlined" class="name-card">
      <mat-card-content class="name-card-content">
        <mat-form-field class="rate-card-name" subscriptSizing="dynamic">
          <mat-label>Rate card name</mat-label>
          <input matInput type="text" [formControl]="formControlRateCardName" maxlength="25">
          @for (errorKey of errorKeys(formControlRateCardName); track errorKey) {
            <mat-error>
              @if (formControlRateCardName.touched && formControlRateCardName.hasError(errorKey)) {
                {{ errorMessages(formControlRateCardName, errorKey) }}
              }
            </mat-error>
          }
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-tab-group [mat-stretch-tabs]="false" mat-align-tabs="start" class="custom-tab rate-card-tabs">
      <mat-tab label="ASSET FINANCE">
        <mat-card appearance="outlined" class="tab-card">
          <mat-card-content>
            <asset-rate-card
              #assetRateCardComponent="assetRateCardComponent"
              [mark]="triggerMark"
              [formControl]="formControlAssetFinanceRateCard"></asset-rate-card>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="BUSINESS TERM LOAN">
        <mat-card appearance="outlined" class="tab-card">
          <mat-card-content>
            <business-loan-rate-card
              #businessLoanRateCardComponent="businessLoanRateCardComponent"
              [mark]="triggerMark"
              [formControl]="formControlBusinessLoanRateCard"></business-loan-rate-card>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="BUSINESS OVERDRAFT">
        <mat-card appearance="outlined" class="tab-card">
          <mat-card-content>
            <business-overdraft-rate-card
              #businessOverdraftRateCardComponent="businessOverdraftRateCardComponent"
              [mark]="triggerMark"
              [formControl]="formControlBusinessOverdraftRateCard"></business-overdraft-rate-card>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="INSURANCE PREMIUM">
        <mat-card appearance="outlined" class="tab-card">
          <mat-card-content>
            <insurance-premium-rate-card
              #insurancePremiumRateCardComponent="insurancePremiumRateCardComponent"
              [mark]="triggerMark"
              [formControl]="formControlInsurancePremiumRateCard"></insurance-premium-rate-card>
          </mat-card-content>
        </mat-card>
      </mat-tab>
    </mat-tab-group>

    <div class="action-bar"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="space-between center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <button class="w-lt-md-100" (click)="cancel($event)" mat-stroked-button color="primary">Cancel</button>
      @if (ratecards) {
        <button class="w-lt-md-100" (click)="update($event)" mat-flat-button color="primary"
          [disabled]="(loader.update.inProgress$ | async)">
          {{ (loader.update.inProgress$ | async) ? 'Updating Rate Card...' : 'Update Rate Card' }}
        </button>
      } @else {
        <button class="w-lt-md-100" (click)="save($event)" mat-flat-button color="primary"
          [disabled]="(loader.save.inProgress$ | async)">
          {{ (loader.save.inProgress$ | async) ? 'Saving Rate Card...' : 'Save Rate Card' }}
        </button>
      }
    </div>
  </div>
}
